type Colour = {
  name: string;
  color: string;
  slug: string;
}

const colours: Colour[] = [
  { name: "Red", color: "#d8222a", slug: "red" },
  { name: "Yellow", color: "#f8af38", slug: "yellow" },
  { name: "Blue", color: "#314b64", slug: "blue" },
  { name: "Pastel Orange", color: "#f18c5b", slug: "pastel-orange" },
  { name: "Body Text", color: "#4a4a4a", slug: "body-colour" },
  { name: "Grey", color: "#404040", slug: "dark-grey" },
  { name: "Pale Grey", color: "#f4f5f7", slug: "pale-grey" },
  { name: "HVO Green", color: "#4f9759", slug: "hvo-green" },
  { name: "Black", color: "#000000", slug: "black" },
  { name: "White", color: "#ffffff", slug: "white" },
];

const mapHexToName = (hex: string): string => {
  for (let colour of colours) {
    if (colour.color === hex) {
      return colour.slug ? `var(--${colour.slug})` : hex;
    }
  }

  return hex;
};

const isElementInViewport = (el: Element): boolean => {
  const box = el.getBoundingClientRect();

  return (
    box.top >= 0 &&
    box.left >= 0 &&
    box.bottom <=
    (window.innerHeight || document.documentElement.clientHeight) &&
    box.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const smallDevice = (): boolean => {
  if (!("matchMedia" in window)) return false;

  return window.matchMedia("(max-width: 767px)").matches;
};


export { colours, mapHexToName, isElementInViewport, smallDevice };
